<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kHR00E/tc-custom/9781788634717.jpg?1721057728819" alt="This image is the cover for the book Primmy's Daughter, The Cornish Clay Sagas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Primmy's Daughter, The Cornish Clay Sagas
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>An American finds romance and revelations as she pieces together her family’s history in Cornwall as World War I begins in this moving saga.</b></p><p> Primmy<b></b>Tremayne’s daughter, Skye, has always been fascinated by her family’s romantic and turbulent history. Travelling from her home in America to Cornwall, she is eager to meet the older generation, especially her grandmother Morwen. On her journey, she finds herself drawn to Philip Norwood, despite his entanglement to another woman. </p><p> Drawn into the world of her new relatives, and of Killigrew Clay, Skye begins to piece the past together. But when the Great War breaks out, new fears burst into clarity as Philip, and half of the clay workforce, enlist. </p><b>Ideal for fans of Lesley Pearse, Lyn Andrews, and Rosie Goodwin.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rowena Summers
      </h2>
      
      <p class="authorDescription body article">Rowena Summers is the pseudonym of Jean Saunders. She was a British writer of romance novels since 1974, and wrote under her maiden name and her pseudonym, as well as the names Sally Blake and Rachel Moore. She was elected the seventeenth Chairman (1993–1995) of the Romantic Novelists’ Association, and she was the Vice-Chairman of the Writers’ Summer School of Swanwick. She was also a member of Romance Writers of America, Crime Writers’ Association and West Country Writers’ Association.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0104d080